/* eslint-disable eslint-comments/disable-enable-pair */
/* eslint-disable react/react-in-jsx-scope */
/* eslint-disable react/prop-types */
import { Table } from 'antd';
import { LoadingOutlined } from '@ant-design/icons';

const CustomTableComponentsPageable = ({
	isMakingApiCall,
	columns,
	dataArray,
	handleSelectedRow,
	handleDoubleClickRow,
	pagination,
	rowSelection,
	onTableChange,
}) => {
	return (
		<div style={{ overflowX: 'auto' }}>
			<Table
				onChange={onTableChange}
				pagination={{
					...pagination, 
					showSizeChanger: true,
					pageSizeOptions: ['10', '20', '50', '100'],
					showTotal: (total, range) =>
						`Showing ${range[0]}–${range[1]} of ${total} items`,
				}}
				loading={{
					spinning: isMakingApiCall,
					indicator: <LoadingOutlined style={{ fontSize: 44 }} spin />,
					tip: (
						<div>
							<h2>Loading...</h2>
						</div>
					),
				}}
				columns={columns}
				dataSource={dataArray}
				rowSelection={rowSelection}
				rowKey="id" 
				onRow={(record) => ({
					onClick: () => handleSelectedRow && handleSelectedRow(record),
					onDoubleClick: () => handleDoubleClickRow && handleDoubleClickRow(record),
				})}
				scroll={{ x: 'max-content', y: '73vh' }}
			/>
		</div>
	);
};

export default CustomTableComponentsPageable;
